export const SET_FEED = 'SET_FEED';
export const SELECT_ACTIVE_CATEGORY = 'SELECT_ACTIVE_CATEGORY';
export const SET_JACKPOT_FILTER = 'SET_JACKPOT_FILTER';
export const SELECT_SORTING_TYPE = 'SELECT_SORTING_TYPE';
export const SET_VIEWMODE = 'SET_VIEWMODE';
export const SET_PGG_GAMES = 'SET_PGG_GAMES';
export const SET_IS_SHOW_BACK = 'SET_IS_SHOW_BACK';
export const SET_GAME_COMPONENT_REF = 'SET_GAME_COMPONENT_REF';

export const setIsShowBack = isShowBack => ({
    type: SET_IS_SHOW_BACK,
    payload: isShowBack
});

export const setGameComponentRef = gameComponentRef => ({
    type: SET_GAME_COMPONENT_REF,
    payload: gameComponentRef
});

export const selectActiveCategory = categoryName => ({
    type: SELECT_ACTIVE_CATEGORY,
    payload: categoryName
});

export const setViewMode = viewModeDetailed => ({
    type: SET_VIEWMODE,
    payload: viewModeDetailed
});

export const selectSortingType = sortingType => ({
    type: SELECT_SORTING_TYPE,
    payload: sortingType
});

export const setJackpotFilter = jackpotFilter => ({
    type: SET_JACKPOT_FILTER,
    payload: jackpotFilter
});

export const setPggGames = (activeCategoryName, pggObj) => ({
    type: SET_PGG_GAMES,
    payload: { activeCategoryName, pggObj }
});

export const setFeedAction = (data) => ({
    type: SET_FEED,
    payload: data
});
